import React from 'react';
import { Trans } from 'react-i18next';

import { getFirstName } from 'utils/helpers';

import UserContainer from 'containers/user-container';

const Name = ({ name = '', email = '', pending, showPending, firstNameOnly }) => (
    <React.Fragment>
        { name ? (firstNameOnly ? getFirstName(name) : name) : email }

        {
            showPending && pending ? <React.Fragment>&nbsp;(<Trans i18nKey="common:pending" />)</React.Fragment> : null
        }
    </React.Fragment>
)

const UserName = ({ id, showPending, firstNameOnly }: any) => <UserContainer id={id}><Name showPending={showPending} firstNameOnly={firstNameOnly} /></UserContainer>;

export default UserName;
